export enum EntityActionEmphasis {
    Disabled = '#',
    Low = '-',
    Medium = '~',
    High = '+',
    Enabled = '!',
}
